import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Popup } from "@progress/kendo-react-popup";
import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/Impacts.scss";
import ImpactTable from "./Component/ImpactTable";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import QualitativeImpact from "./Component/QualitativeImpact";

export default class ImpactsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      impactslist: [],
      expandedRowList:[],
      currentChangedValue: {},
      openDeleteModelFlag: false,
      currentRowId: 0,
      selected: 0,
      loader: false,
      skip: 0,
      take: 10,
      visibleTemplate: false,
      value: [],
      rangeList: [],
      probabilityColumns: [],
      dynamicHeatmapProbabilityRange: [],
      impactvalue: "",
      errortoaster: false,
      heatmapCount: "",
      isimpactconfiguration:false,
      orderId_val: "",

    };
    this.expandChange = this.expandChange.bind(this);
  }
  componentDidMount() {
    this.init();
  }
  init = async () => {
    await this.getHeatmapConfiguration();
    this.getImpactList();
  };
  getHeatmapConfiguration = async () => {
    try {
      let response = await Api.GetHeatmapConfiguration();
      if (response.status === 200) {
        let arr = response.dynamicHeatmapProbabilityRange;

        let rangeArray = [];
        arr = arr?.map((item) => {
          item[item.fullDescription] = item.probabilityRangeValue;
          return item;
        });
        rangeArray = arr.map((column, index) => (
          <Column
            key={index}
            field={column.fullDescription}
            title={column.fullDescription + " From"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={index === 0 ? false : true}
          />
        ));
        this.setState({
          loader: false,
          dynamicHeatmapProbabilityRange:
            response.dynamicHeatmapProbabilityRange,
          probabilityColumns: rangeArray,
          heatmapCount: response.heatmapCount,
          orderId_val: response.dynamicHeatmapProbabilityRange.orderId,

        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  deleteImpactOpen = (row) => {
    this.setState({
      openDeleteModelFlag: true,
      currentRowId: row.impactId,
    });
  };

  deleteImpactClose = () => {
    this.setState({ openDeleteModelFlag: false, currentRowId: 0 });
  };

  getImpactList = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let response = await Api.GetAllImpactAndThreshold();
      if (response.status === 200 && response.impact) {
        let filteredList = response.impact.filter(
          (item) => item.impactType === "Quantitative"
        );
        filteredList.map(item => {
          if (this.checkIdExists(item.impactId)) {
            item["expanded"]=true;
            // return { ...item, expanded: true };
          }else{
            item["expanded"]=false;
          }
          return item;
        });
        this.dynamicCols(filteredList);
        this.setState({ impactslist: filteredList, loader: false });
      } else {
        this.setState({ ...this.state, loader: false, impactslist: [] });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  checkIdExists = (id) => {
    return this.state.expandedRowList.some(item=>item === id);
  };
  getFieldName = (orderId) => {
    let obj = this.state.dynamicHeatmapProbabilityRange.find(
      (item) => item.orderId === orderId
    );
    return obj?.fullDescription;
  };
  dynamicCols = (data) => {
    try {
      data.map((res) => {
        res.impactThresholdValue.map((item) => {
          let field = this.getFieldName(item.orderId);
          res[field] = item.thresholdValue;
        });
      });
    } catch (error) {
      // this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  editImpact(row) {
    const token =
      secureLocalStorage.getItem("loggedClient") == "user"
        ? secureLocalStorage.getItem("userKey")
        : secureLocalStorage.getItem("tenantKey");
    const loggedClient = secureLocalStorage.getItem("loggedClient");
    this.props.history.push({
      pathname: `/${loggedClient}/${token}/home/impacts/add`,
      editImpactData: row.dataItem,
    });
  }

  async removeImapct() {
    try {
      this.setState({ ...this.state, loader: true });

      var req = {
        ImpactId: this.state.currentRowId,
        DeletedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        // thresholdId:this.state.thresholdId
      };
      let response = await Api.deleteImpactThreshold(req);
      if (response.status === 200) {
        toastr.success(response.message);
        this.setState({ ...this.state, loader: false });
        this.deleteImpactClose();
        this.getImpactList();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  }

  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };
  onEditCell = () => {};

  expandChange(event) {
    event.dataItem.expanded = event.value;
    let impactId = event.dataItem.impactId;
    const ids = this.state.impactslist
      .filter((item) => item.expanded === true)
      .map((item) => item.impactId);
    this.setState({ ...this.state, expandedRowList: ids });
    if (!event.value || event.dataItem.impactThresholds) {
      return;
    }
    let impactslist = this.state.impactslist.slice();
    let index = impactslist.findIndex((d) => d.impactId === impactId);
    impactslist[index].impactThresholds = this.state.impactslist.filter(
      (d) => d.impactId === impactId
    );
    this.setState({ impactslist: impactslist });
  }

  addRecord = () => {
    const { impactslist } = this.state;
    const newRecord = {};
    this.setState({
      impactslist: [newRecord, ...impactslist],
      editID: newRecord.impactId,
      skip: 0,
      take: 10,
    });
  };
  discard = () => {
    const impactslist = [...this.state.impactslist];
    impactslist.splice(0, 1);
    this.setState({ impactslist });
  };

  cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];

    const additionalProps =
      cellField && cellField === inEditField
        ? {
            ref: (td) => {
              const input = td && td.querySelector("input");
              const activeElement = document.activeElement;

              if (
                !input ||
                !activeElement ||
                input === activeElement ||
                !activeElement.contains(input)
              ) {
                return;
              }

              if (input.type === "checkbox") {
                input.focus();
              } else {
                input.select();
              }
            },
          }
        : {
            onClick: () => {
              this.enterEdit(dataItem, cellField);
            },
          };
    if (tdElement && tdElement.props) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps },
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  rowRender = (trElement) => {
    const trProps = {
      ...trElement.props,
      onMouseDown: (event) => {
        event.preventExit = true;
        clearTimeout(event.preventExitTimeout);
        event.preventExitTimeout = setTimeout(() => {
          event.preventExit = undefined;
        });
      },
      onBlur: (event) => {
        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            this.exitEdit();
          });
        }
        if (
          this.state.editField != "expanded" &&
          this.state.currentChangedValue &&
          this.state.currentChangedValue.impactId
        ) {
          this.updateRecord(this.state.currentChangedValue);
        }
      },
      onFocus: (event) => {
        clearTimeout(event.blurTimeout);
      },
    };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };

  enterEdit = (dataItem, field) => {
    const dataValue = this.state.impactslist.map((item) => ({
      ...item,
      inEdit: item.impactId === dataItem.impactId ? field : undefined,
    }));
    this.setState({
      impactslist: dataValue,
      currentChangedValue: dataItem,
      editField: field,
      impactvalue: dataItem,
    });
  };
  impactvalidation = (impactThresholdValue) => {
    let errortoaster = false;

    for (var i = 0; i < impactThresholdValue.length - 1; i++) {
      if (
        impactThresholdValue[i].ThresholdValue >=
        impactThresholdValue[i + 1].ThresholdValue
      ) {
        errortoaster = true;
        return errortoaster;
      }
    }
    return errortoaster;
  };
  exitEdit = () => {
    const dataValue = this.state.impactslist.map((item) => ({
      ...item,
      inEdit: undefined,
    }));
    this.setState({
      impactslist: dataValue,
    });
  };
  isValidation = (dataItem) => {
    let flag = false;
    if (
      dataItem.name &&
      dataItem.name.trim() &&
      dataItem.name != "" &&
      dataItem.units &&
      dataItem.units != "" &&
      dataItem.description &&
      dataItem.description != ""
    ) {
      flag = true;
    }
    return flag;
  };

  isValidateThresholdRange = (dataItem) => {
    if (dataItem.veryLowRangeFromValue != 0) {
      toastr.error("Very low range value should be equal to 0");
      return true;
    } else if (dataItem.veryLowRangeFromValue >= dataItem.lowRangeFromValue) {
      toastr.error(
        "Low range value should be greater than very low range value"
      );
      return true;
    } else if (dataItem.lowRangeFromValue >= dataItem.mediumRangeFromValue) {
      toastr.error("Medium range value should be greater than low range value");
      return true;
    } else if (dataItem.mediumRangeFromValue >= dataItem.highRangeFromValue) {
      toastr.error(
        "High range value should be greater than medium range value"
      );
      return true;
    } else if (dataItem.highRangeFromValue >= dataItem.veryHighRangeFromValue) {
      toastr.error(
        "Very high range value should be greater than high range value"
      );
      return true;
    }
  };

  updateRecord = async (dataItem) => {
    try {
      if (!this.isValidation(dataItem)) {
        toastr.error("Please fill all the fields");
        return;
      }

      if (dataItem.name.includes('.')) {
        toastr.error("Impact Name must not contain '.'");
        return;
      }

    
      this.setState({ ...this.state, loader: true });
      let name = dataItem.name.trim();
      let description = dataItem.description;
      let units = dataItem.units;
      let impactId = dataItem.impactId;
      let thresholdId = dataItem.thresholdId;
      delete dataItem["inEdit"];
      delete dataItem["description"];
      delete dataItem["units"];
      delete dataItem["name"];

      let arr = [];
      var i = 1;
      for (let [key, value] of Object.entries(dataItem)) {
        if (
          this.state.dynamicHeatmapProbabilityRange.some(
            (item) => item.fullDescription === key
          )
        ) {
          arr.push({
            OrderId: this.getOrderId(key),
            ThresholdValue: value,
          });
          i++;
        }
      }
      if (arr.length < this.state.heatmapCount) {
        this.setState({ ...this.state, loader: false });
        toastr.error("Please fill all the fields");

        return true;
      }
      if (this.impactvalidation(arr)) {
        this.setState({ ...this.state, loader: false });
        toastr.error(
          "Entered value should be between the values entered in lower range and in the higher range"
        );
        return;
      }

      var request = {
        Name: name,
        description: description,
        ImpactId: impactId,
        thresholdId: thresholdId,
        units: units,
        isDefault: true,
        impactThresholdValue: arr,
      };

      let response = await Api.updateImpactThreshold(request);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          loader: false,
          currentChangedValue: {},
        });
        toastr.success(response.message);
        this.getImpactList();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  getOrderId = (field) => {
    let obj = this.state.dynamicHeatmapProbabilityRange.find(
      (item) => item.fullDescription === field
    );
    return obj?.orderId;
  };
  getOrderIdvalue = (orderId) => {
    let obj = this.state.dynamicHeatmapProbabilityRange.find(
      (item) => item.fullDescription === orderId
    );
    return obj?.orderId || "NA";
  };
  saveNewRecord = async (dataItem) => {
    try {
      if (!this.isValidation(dataItem)) {
        toastr.error("Please fill all the fields");
        return;
      }

      if (dataItem.name.includes('.')) {
        toastr.error("Impact Name must not contain '.'");
        return;
      }
      
      this.setState({ loader: true });
      let name = dataItem.name.trim();
      let description = dataItem.description;
      let units = dataItem.units;
      delete dataItem["inEdit"];
      delete dataItem["description"];
      delete dataItem["units"];
      delete dataItem["name"];

      let arr = [];
      var i = 1;
      for (let [key, value] of Object.entries(dataItem)) {
        if (
          this.state.dynamicHeatmapProbabilityRange.some(
            (item) => item.fullDescription === key
          )
        ) {
          arr.push({
            OrderId: this.getOrderId(key),
            ThresholdValue: value,
          });
          i++;
        }
      }
      let newArr = [{ OrderId: 1, ThresholdValue: 0 }].concat(arr);

      if (newArr.length < this.state.heatmapCount) {
        this.setState({ ...this.state, loader: false });
        dataItem["description"] = description;
        dataItem["units"] = units;
        dataItem["name"] = name;
        toastr.error("Please fill all the fields");

        return true;
      }
      if (this.impactvalidation(newArr)) {
        this.setState({ ...this.state, loader: false });
        dataItem["description"] = description;
        dataItem["units"] = units;
        dataItem["name"] = name;
        toastr.error(
          "Entered value should be between the values entered in lower range and in the higher range"
        );

        return;
      }

      var request = {
        Name: name,
        description: description,
        units: units,
        isDefault: true,
        impactThresholdValue: newArr,
      };
      let response = await Api.AddImpactThreshold(request);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.getImpactList();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  actionButtons = (event) => {
    let eventData = event.dataItem;
    return (
      <td className="editBtns">
        {eventData.impactId ? (
          <ul className="actionIcon">
            <li onClick={() => this.deleteImpactOpen(eventData)}>
              <a
                title="Delete"
                className="redbtn icon"
                // onClick={() => this.deleteImpactOpen(eventData)}
              >
                <img src={Images.TRASH} width="12" alt="Trash" />
              </a>
            </li>
          </ul>
        ) : (
          <ul className="actionIcon">
            <li>
              <a
                title="Save Action"
                className="greenbtn icon"
                onClick={() => this.saveNewRecord(eventData)}
              >
                <img src={Images.CHECKGREEN} width="10" alt="save" />
              </a>
            </li>
            <li>
              <a
                title="Discard"
                onClick={() => this.discard(eventData)}
                className="redbtn  icon"
              >
                <img src={Images.CLOSE} width="10" alt="edit" />
              </a>
            </li>
          </ul>
        )}
      </td>
    );
  };

  itemChange = (event) => {
    const changedValue = { ...event.dataItem, [event.field]: event.value };
    const dataValue = this.state.impactslist.map((item) =>
      item.impactId === event.dataItem.impactId
        ? { ...item, [event.field]: event.value }
        : item
    );
    this.setState({
      ...this.state,
      currentChangedValue: changedValue,
      impactslist: dataValue,
    });
  };

  validateImpactName = (dataItem) => {
    if (!dataItem.name.match(/^[a-zA-Z0-9\s]*$/)) {
      return false;
    }
    return true;
  };
  handleSelect = (e) => {
    if (e.selected == 1) {
      // this.getDeletedUser();
    }

    this.setState({
      selected: e.selected,
    });
  };
  handleimpactConfiguration = () => {
    this.setState({
      isimpactconfiguration: !this.state.isimpactconfiguration,
    });
  };
  closeimpactconfigration = () => {
    if (this.state.isimpactconfiguration) {
      this.setState({
        isimpactconfiguration: false,
      });
    }
  };
  updaterangeconfiguration = async () => {
    let fullDescription = this.state.dynamicHeatmapProbabilityRange.map((e) =>
      e.fullDescription.toLowerCase()
    );
    for (let i = 0; i < fullDescription.length; i++) {
      if (
        !fullDescription[i] ||
        fullDescription[i] == "" ||
        fullDescription[i] === null ||
        fullDescription[i] === undefined
      ) {
        toastr.error("Full Description is Required");
        return;
      }
    }
    fullDescription = fullDescription.map(function (str) {
      return str.replaceAll(/\s/g, "");
    });
    const temp = new Set(fullDescription);
    let result = temp.size !== fullDescription.length;
    if (result === true) {
      toastr.error("Full Description value already exist");
    }
    let abbreviation = this.state.dynamicHeatmapProbabilityRange.map((e) =>
      e.abbreviation.toLowerCase()
    );
    for (let i = 0; i < abbreviation.length; i++) {
      if (
        !abbreviation[i] ||
        abbreviation[i] == "" ||
        abbreviation[i] === null ||
        abbreviation[i] === undefined
      ) {
        toastr.error("Abbreviation is Required");
        return;
      }
    }
    let tempval = new Set(abbreviation);
    let value = tempval.size !== abbreviation.length;
    if (value === true) {
      toastr.error("Abbreviation value already exist");
    }

    let arr = [];
    this.state.dynamicHeatmapProbabilityRange.map((item, index) => {
      arr.push({
        OrderId: item.orderId,
        fullDescription: item.fullDescription,
        abbreviation: item.abbreviation,
        ProbabilityDescription: item.probabilityDescription,
        probabilityRangeValue: item.probabilityRangeValue,
      });
    });

    const request = {
      ProbabilityRangeLabel: arr,
    };
    let response = await Api.UpdateProbabilityRange(request);
    if (response.status === 200) {
      if (result === false && value === false) {
        toastr.success(response.message);
        this.closeimpactconfigration();
        this.init();
      }
    } else {
      toastr.error(response.message);
    }
  };
  getFullDescriptionValue = (i) => {
    let obj = this.state.dynamicHeatmapProbabilityRange[i];
    return obj?.fullDescription;
  };
  getAbbreviationValue = (i) => {
    let obj = this.state.dynamicHeatmapProbabilityRange[i];
    return obj?.abbreviation;
  };
  handleFullDescription = (e, i) => {
    try {
      let probabiltyArray = this.state.dynamicHeatmapProbabilityRange.map(
        (item, index) => {
          if (index === i) {
            item["fullDescription"] = e.target.value?.trim();
          }
          return item;
        }
      );
      this.setState({ dynamicHeatmapProbabilityRange: probabiltyArray });
    } catch (err) {
      console.log(err);
    }
  };
  handleAbbreviation = (e, i) => {
    try {
      let probabiltyArray = this.state.dynamicHeatmapProbabilityRange.map(
        (item, index) => {
          if (index === i) {
            item["abbreviation"] = e.target.value?.trim()?.toUpperCase();
          }
          return item;
        }
      );
      this.setState({ dynamicHeatmapProbabilityRange: probabiltyArray });
    } catch (err) {
      console.log(err);
    }
  };
  getDynamicMatrix = () => {
    let matrixfields = [];
    for (let i = 0; i < this.state.heatmapCount; i++) {
      matrixfields.push(
        <div className="rm-field-container">
          <div className="rowfield">
            <div
              style={{
                paddingBlock: "5px",
                marginLeft: "40px",
                color: "#ffffff99",
              }}
            >
              Full Description {i + 1}
              <span style={{ color: "#e76767" }}>*</span>
            </div>
            <input
              type="text"
              name="Label"
              className="form-control"
              autocomplete="off"
              value={this.getFullDescriptionValue(i)}
              onChange={(e) => this.handleFullDescription(e, i)}
              style={{ marginLeft: "10px", textTransform: "capitalize" }}
            />

            <div
              style={{
                padding: "5px 0px 5px 5px",
                marginLeft: "60px",
                color: "#ffffff99",
                float:'left'
              }}
            >
              Abbreviation <span style={{ color: "#e76767" }}>*</span>
            </div>
            <input
              type="text"
              name="Label"
              className="form-control"
              style={{ marginLeft: "10px", textTransform: "uppercase" }}
              maxlength="3"
              // autocomplete="off"
              value={this.getAbbreviationValue(i)}
              onChange={(e) => this.handleAbbreviation(e, i)}
            />
          </div>
        </div>
      );
    }

    return matrixfields;
  };

  render() {
    return (
      <div className="impactsContainer">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}

        <div className="impactsTableCont" id="impactsTableCont">
          <TabStrip selected={this.state.selected} onSelect={this.handleSelect}>
            <TabStripTab title="Quantitative">
              <div className="dataGrids">
                <div className="impactsHeader">
                  <h4>Quantitative Variable</h4>
                  <div className="addImpactrow">
                    <button
                      title="Add new"
                      className="addthreshold"
                      onClick={this.addRecord}
                      style={{width:'130px'}}
                    >
                      Add
                    </button>
                  </div>
                </div>
                <Grid
                  data={this.state.impactslist.slice(
                    this.state.skip,
                    this.state.take + this.state.skip
                  )}
                  reorderable
                  resizable
                  skip={this.state.skip}
                  take={this.state.take}
                  total={this.state.impactslist.length}
                  pageable={true}
                  onPageChange={this.pageChange}
                  expandField="expanded"
                  onExpandChange={this.expandChange}
                  detail={(props) => (
                    <ImpactTable
                      {...props}
                      getImpactList={this.getImpactList}
                      dynamicHeatmapProbabilityRange={
                        this.state.dynamicHeatmapProbabilityRange
                      }
                      heatmapCount={this.state.heatmapCount}
                    />
                  )}
                  cellRender={this.cellRender}
                  rowRender={this.rowRender}
                  editField="inEdit"
                  onItemChange={this.itemChange}
                >
                  <Column
                    title="Actions"
                    cell={this.actionButtons}
                    width="65px"
                    locked={true}
                  />
                  <Column
                    field="name"
                    title="Impact Name *"
                    width="150px"
                    locked={true}
                  />
                  <Column
                    field="description"
                    title="Description *"
                    width="170px"
                  />
                  <Column field="units" title="Units *" width="50px" />
                  {this.state.probabilityColumns}
                </Grid>
              </div>
            </TabStripTab>
            <TabStripTab title="Qualitative">
              <div className="dataGrids">
                <QualitativeImpact
                  dynamicHeatmapProbabilityRange={
                    this.state.dynamicHeatmapProbabilityRange
                  }
                  heatmapCount={this.state.heatmapCount}
                />
              </div>
            </TabStripTab>
          </TabStrip>
        </div>
 <div
            className="impactconfigurationbtn"
            onClick={this.handleimpactConfiguration}
          >
            Impact Definition
          </div>

        <Popup
          show={this.state.openDeleteModelFlag}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this impact?</h3>
            <div className="btnCont">
              <button onClick={() => this.removeImapct()} className="deleteBtn">
                Delete
              </button>
              <button onClick={this.deleteImpactClose} className="cancelBtn">
                Cancel
              </button>
            </div>
          </div>
        </Popup>
        <Popup
          show={this.state.isimpactconfiguration}
          popupClass={"popup-content"}
        >
          <div className="impactconfiguration">
            <label>Impact Definition</label>
            <p>
              Note: Range names must be entered in increasing order of severity
              i.e. Lowest to Highest. For example, if the selection is 3 x 3 and
              the range names are Low, Medium and High, Full Description 1 must
              be Low, Full Description 2 must be Medium and Full Description 3
              must be High.
            </p>
            <div className="impactdynamix_fields">
              {this.getDynamicMatrix()}
            </div>
            <div className="impact_btn">
              <div
                className="imp_update"
                onClick={this.updaterangeconfiguration}
              >
                UPDATE
                </div>
                <div
                className="imp_cancel"
                onClick={this.closeimpactconfigration}
              >
                CANCEL
                </div>
              </div>
            </div>
          </Popup>

      </div>
    );
  }
}
